import {obtenerDiasDisponibles} from "./obtenerDiasDisponibles";

export const verificarDiaDisponible = (e, arrSemana) =>{
    let numDia = e.format('d')
    let diasDisponibles = obtenerDiasDisponibles(arrSemana)
    return !diasDisponibles.includes(parseInt(numDia))
}